import HTTP from "../../http";

const EMAIL_ENDPOINT = "/email";
const RESET_PASSWORD_ENDPOINT = "/resetPassword";

export async function resetPassword(password, token) {
  return await HTTP.put(
    EMAIL_ENDPOINT + RESET_PASSWORD_ENDPOINT,
    { password, token },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
